import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FieldCrops } from '../models/field-crops';
import { BaseService } from './base-service.service';

@Injectable({
  providedIn: 'root'
})
export class FieldCropsService extends BaseService {
  constructor(private http: HttpClient) { super(); }

  getList(campaignId: number, fieldId: number): Observable<any> {
    return this.http.get(this.getUrl(`FieldCrops/GetList/Campaign/${campaignId}/Field/${fieldId}`));
  }

  save(field: FieldCrops, id?: number): Observable<any> {
    if (id == null) {
      return this.http.post(`${this.getUrl('FieldCrops')}`, field);
    }
  }

  delete(campaignId: number, fieldId: number, cropId: number): Observable<any> {
    return this.http.delete(this.getUrl(`FieldCrops/Campaign/${campaignId}/Field/${fieldId}/Crop/${cropId}`));
  }
}
